import { useCallback } from 'react';
import { useUpdateTagMutation } from 'shared/hooks/queries/use-update-tag-mutation';
import { TagGroupBy } from 'shared/types/sorting-mode';

import { useTagById } from './use-tag-by-id';

export const useUpdateTagGroupBy = (tagId?: string) => {
  const { mutate } = useUpdateTagMutation();
  const tag = useTagById(tagId);

  return useCallback(
    (groupBy: TagGroupBy) => {
      if (tag) {
        mutate({
          id: tag.id,
          taskGroupBy: groupBy,
        });
      }
    },
    [mutate, tag],
  );
};
